function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ic /2/ Facebook");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "News",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-/-News-Detail",
  transform: "translate(-165.000000, -407.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic-/2/-Facebook",
  transform: "translate(152.000000, 400.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 40,
  height: 40
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7357159,32.3450457 L21.7357159,21.1058954 L25.5746026,21.1058954 L26.1296224,16.7274061 L21.7357159,16.7274061 L21.7357159,13.9831417 C21.7357159,12.7497645 22.1519807,11.7938971 23.9403778,11.7938971 L26.2683773,11.7938971 L26.2683773,7.81625544 C25.6671059,7.81625544 24.3412254,7.6775005 22.8303382,7.6775005 C19.9163061,7.49254026 17.4009041,9.69782417 17.2030545,12.6110095 C17.1799599,12.8880389 17.1799599,13.1665098 17.2030545,13.4435392 L17.2030545,16.7274061 L13.3333333,16.7274061 L13.3333333,21.1058954 L17.2184717,21.1058954 L17.2184717,32.3450457 L21.7357159,32.3450457 Z",
  id: "Path_1",
  fill: "#004E44"
}))));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "26px",
    viewBox: "0 0 14 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.f986f185.svg";
export { ForwardRef as ReactComponent };